import { ListFilter } from './ListFilter';
import { ListResponse } from './response/ListResponse';

export interface ListState<T, Z extends ListFilter> {
  loading: boolean;
  response: ListResponse<T>;
  filter: Z;
}
